import React, { useState } from 'react';
import { ArticleDialog } from '../components';
import { Confluence } from '../interfaces';

interface IProps {
  parentId?: number | null;
  onCreate?(article: Confluence.IArticle): void;
  children(onClick: () => void): void;
}

const CreateArticle = ({ parentId = null, onCreate, children }: IProps) => {
  const [opened, setOpened] = useState(false);

  return (
    <>
      {children(() => setOpened(true))}

      <ArticleDialog parentId={parentId} open={opened} onCreateOrUpdate={onCreate} onClose={() => setOpened(false)} />
    </>
  );
};

export default CreateArticle;
